/**
 * Weiterleitung auf die Belegseite, wenn nur die Kennung bekannt ist.
 *
 * Lagerbewegungen, Protokoll und Berichte tragen die Belegkennung, aber
 * nicht den Typ - der bestimmt jedoch die Adresse (/verkauf/rechnungen/...).
 * Diese Seite holt den Beleg und springt an die richtige Stelle.
 */

import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import type { DocumentType } from '@erp/shared';

import { api } from '../api/client';
import { EmptyState, LoadingBlock } from '../components/ui';
import { DOCUMENT_ROUTES, FRAMEWORK_ROUTE } from './DocumentsPage';

export function DocumentRedirect() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data, isError } = useQuery({
    queryKey: ['document', id],
    queryFn: () => api.get<{ document: { id: string; type: DocumentType; isFrameworkContract?: boolean } }>(`/api/documents/${id}`),
    enabled: Boolean(id),
    retry: false,
  });

  useEffect(() => {
    if (!data) return;
    const base = data.document.isFrameworkContract ? FRAMEWORK_ROUTE : DOCUMENT_ROUTES[data.document.type];
    navigate(`${base}/${data.document.id}`, { replace: true });
  }, [data, navigate]);

  if (isError) {
    return <EmptyState title="Beleg nicht gefunden" hint="Der Beleg existiert nicht mehr oder Sie dürfen ihn nicht sehen." />;
  }
  return <LoadingBlock text="Beleg wird geöffnet …" />;
}
